module.exports = __webpack_public_path__ + "static/media/platform-cloud.4d4c7168.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/platform-cloud.png
// module id = 13899
// module chunks = 0